'use client'

import Button from '@mui/material/Button'
import { FC } from 'react'
import tappingCardGeneric from '../../../public/assets/tapping-card-generic.png'
import events from '../../constants/analytics'
import HeroSection from '../../shared/components/HeroSection'
import JoinUsSection from '../../shared/components/JoinUsSection'
import { useAnalytics } from '../../shared/context/Analytics'
import useViewPage from '../../shared/hooks/useViewPage'
import {
  AboutSection,
  BeliefsSection,
  MissionStatementSection,
  TestimonialVideoSection,
} from './components'

const AboutPage: FC = () => {
  useViewPage(events.EVENTS.INIT.ViewAboutPage)
  const { track } = useAnalytics()

  return (
    <>
      <HeroSection
        title="Credit for building momentum"
        imageSrc={tappingCardGeneric}
        imageAltText="Tapping Mission Lane credit card"
      />
      <MissionStatementSection />
      <AboutSection />
      <BeliefsSection />
      <TestimonialVideoSection />
      <JoinUsSection>
        <Button
          href="/careers"
          variant="contained"
          className="w-full md:w-fit"
          onClick={() => track?.(events.EVENTS.INTERACTION.ClickViewCareers)}
        >
          View Careers
        </Button>
      </JoinUsSection>
    </>
  )
}

export default AboutPage
